// Render-less mount point for the presence heartbeat. Lives as a component
// (not a bare hook call) so RequireAuth can mount it without re-rendering
// on heartbeat activity.
import { useOnlinePresenceHeartbeat } from "../hooks/useOnlinePresenceHeartbeat";

/**
 * Emits presence heartbeats while mounted; renders nothing.
 *
 * @example
 * <RequireAuth>… <OnlinePresenceHeartbeat /> …</RequireAuth>
 */
export function OnlinePresenceHeartbeat(): null {
  useOnlinePresenceHeartbeat();
  return null;
}
